export default function Django_Study_Plan() {
  return <div>Django_Study_Plan Component</div>;
}
